module.exports = __webpack_public_path__ + "media/images/video/rowhouse-app-promo-725fd594ab96227d2c3796ba94bc7cef.png";